import { KeyValueModel } from "model";
import { EnumTipoExibicao } from "model/enums/enum-tipo-exibicao";

export const TipoExibicaoMock: KeyValueModel[] = [
    new KeyValueModel(EnumTipoExibicao.Todos, "Todos as áreas"),
    new KeyValueModel(EnumTipoExibicao.Cardapio, "Cardápio"),
    new KeyValueModel(EnumTipoExibicao.Catalogo, "Catálogo"),
    new KeyValueModel(EnumTipoExibicao.NaoExibir, "Não exibir"),
];
